// extracted by mini-css-extract-plugin
export default {"title":"styles_title__ehQw5","txt":"styles_txt__YOQLb","col":"styles_col__VUEFk"};